// sceneIcons — the ONLY icons a motion scene may use. 2026-09-02.
//
// A model picking emoji was measured picking 🛑 for "pack yourself" and ❌
// for "move on a weekday" (probe, 9/2). So the scene vocabulary is a fixed
// set of stroke icons on a 24×24 grid, chosen by NAME — either by the
// keyword map below (deterministic, 0 ms) or by the director model choosing
// from this list. An unknown name renders as a numbered badge, never a
// wrong picture.
//
// Every icon: one or more path strings, stroke-only, round caps, 2px.

export const ICONS = {
  box:      ['M3 8l9-4 9 4v9l-9 4-9-4z', 'M3 8l9 4 9-4', 'M12 12v9'],
  truck:    ['M2 7h11v9H2z', 'M13 10h4l3 3v3h-7', 'M6 19a2 2 0 100-4 2 2 0 000 4z', 'M17 19a2 2 0 100-4 2 2 0 000 4z'],
  house:    ['M3 11l9-8 9 8', 'M5 10v10h14V10', 'M10 20v-6h4v6'],
  calendar: ['M4 5h16v15H4z', 'M4 10h16', 'M8 3v4', 'M16 3v4'],
  dollar:   ['M12 3v18', 'M16 7H10a3 3 0 000 6h4a3 3 0 010 6H7'],
  clock:    ['M12 21a9 9 0 100-18 9 9 0 000 18z', 'M12 7v5l3 2'],
  phone:    ['M7 3h10v18H7z', 'M11 18h2'],
  check:    ['M5 12l5 5L20 7'],
  x:        ['M6 6l12 12', 'M18 6L6 18'],
  star:     ['M12 3l2.8 6 6.2.7-4.6 4.3 1.3 6.3L12 17l-5.7 3.3 1.3-6.3L3 9.7 9.2 9z'],
  tools:    ['M14 6l4 4', 'M4 20l8-8', 'M13 4a4 4 0 015 5l-2 2-5-5z', 'M9 15l-5 5'],
  bulb:     ['M9 18h6', 'M10 21h4', 'M12 3a6 6 0 00-4 10.5c.7.7 1 1.5 1 2.5h6c0-1 .3-1.8 1-2.5A6 6 0 0012 3z'],
  chartUp:  ['M3 20h18', 'M5 16l5-5 4 3 6-7', 'M16 7h4v4'],
  chartDown:['M3 20h18', 'M5 8l5 5 4-3 6 7', 'M16 17h4v-4'],
  people:   ['M8 12a3 3 0 100-6 3 3 0 000 6z', 'M16 12a3 3 0 100-6 3 3 0 000 6z', 'M2 20a6 6 0 0112 0', 'M13 15a6 6 0 019 5'],
  person:   ['M12 11a4 4 0 100-8 4 4 0 000 8z', 'M4 21a8 8 0 0116 0'],
  mail:     ['M3 6h18v12H3z', 'M3 7l9 6 9-6'],
  message:  ['M4 5h16v11H9l-5 4z'],
  pin:      ['M12 21s-7-6.5-7-11a7 7 0 0114 0c0 4.5-7 11-7 11z', 'M12 12a2 2 0 100-4 2 2 0 000 4z'],
  camera:   ['M4 8h4l2-3h4l2 3h4v11H4z', 'M12 17a3.5 3.5 0 100-7 3.5 3.5 0 000 7z'],
  shield:   ['M12 3l8 3v6c0 5-3.5 8-8 9-4.5-1-8-4-8-9V6z'],
  key:      ['M14 11a4 4 0 100-8 4 4 0 000 8z', 'M11 10l-8 8', 'M6 15l2 2', 'M9 12l2 2'],
  cart:     ['M3 4h3l2.5 11h10L21 8H7', 'M10 20a1 1 0 100-2 1 1 0 000 2z', 'M17 20a1 1 0 100-2 1 1 0 000 2z'],
  tag:      ['M3 12V4h8l9 9-8 8z', 'M7 8h.01'],
  gift:     ['M3 9h18v4H3z', 'M5 13v8h14v-8', 'M12 9v12', 'M12 9c-3 0-5-1-5-3s3-2 5 3c2-5 5-5 5-3s-2 3-5 3z'],
  sun:      ['M12 17a5 5 0 100-10 5 5 0 000 10z', 'M12 2v3', 'M12 19v3', 'M2 12h3', 'M19 12h3', 'M5 5l2 2', 'M17 17l2 2', 'M5 19l2-2', 'M17 7l2-2'],
  cloud:    ['M7 18a4 4 0 01-.5-8 6 6 0 0111.5 2h.5a3 3 0 010 6z'],
  leaf:     ['M20 4C9 4 4 10 4 18c8 0 14-5 16-14z', 'M4 18l8-8'],
  heart:    ['M12 20s-7-4.5-7-10a4 4 0 017-2.5A4 4 0 0119 10c0 5.5-7 10-7 10z'],
  book:     ['M4 4h7a2 2 0 012 2v14a2 2 0 00-2-2H4z', 'M20 4h-7a2 2 0 00-2 2v14a2 2 0 012-2h7z'],
  pencil:   ['M4 20l4-1L19 8l-3-3L5 16z', 'M14 7l3 3'],
  search:   ['M11 18a7 7 0 100-14 7 7 0 000 14z', 'M20 20l-4-4'],
  gear:     ['M12 15a3 3 0 100-6 3 3 0 000 6z', 'M12 2v3', 'M12 19v3', 'M2 12h3', 'M19 12h3', 'M4.9 4.9l2.1 2.1', 'M17 17l2.1 2.1', 'M4.9 19.1L7 17', 'M17 7l2.1-2.1'],
  lock:     ['M6 11h12v10H6z', 'M8 11V7a4 4 0 018 0v4'],
  flag:     ['M5 21V4', 'M5 4h13l-3 4 3 4H5'],
  trash:    ['M4 7h16', 'M9 7V4h6v3', 'M6 7l1 14h10l1-14'],
  recycle:  ['M7 19h10l2-4', 'M12 4l3 5', 'M5 15l3-5', 'M9 9H5l2 4', 'M15 9l4 6-2 4'],
  scale:    ['M12 3v18', 'M6 6h12', 'M4 12l2-6 2 6a2 2 0 01-4 0z', 'M16 12l2-6 2 6a2 2 0 01-4 0z', 'M8 21h8'],
  rocket:   ['M12 3c3 3 4 7 3 11l-3 3-3-3c-1-4 0-8 3-11z', 'M9 14l-3 2 1 3', 'M15 14l3 2-1 3', 'M12 10h.01'],
  fire:     ['M12 21c-4 0-6-3-6-6 0-3 2-5 3-7 0 2 1 3 2 3 0-3 1-6 3-8 0 4 4 6 4 11 0 4-2 7-6 7z'],
  water:    ['M12 3s6 7 6 11a6 6 0 01-12 0c0-4 6-11 6-11z'],
  bolt:     ['M13 2L4 14h7l-1 8 9-12h-7z'],
  plug:     ['M9 3v5', 'M15 3v5', 'M6 8h12v4a6 6 0 01-12 0z', 'M12 18v3'],
  car:      ['M4 15l2-6h12l2 6v4H4z', 'M4 15h16', 'M7 19a1 1 0 100-2 1 1 0 000 2z', 'M17 19a1 1 0 100-2 1 1 0 000 2z'],
  bike:     ['M6 19a3 3 0 100-6 3 3 0 000 6z', 'M18 19a3 3 0 100-6 3 3 0 000 6z', 'M6 16l4-8h6l2 8', 'M10 8h4'],
  plane:    ['M2 13l20-8-6 16-3-6z', 'M22 5l-9 10'],
  music:    ['M9 18a2 2 0 100-4 2 2 0 000 4z', 'M19 16a2 2 0 100-4 2 2 0 000 4z', 'M11 16V5l10-2v11'],
  briefcase:['M3 8h18v12H3z', 'M9 8V5h6v3', 'M3 13h18'],
  list:     ['M8 6h13', 'M8 12h13', 'M8 18h13', 'M3 6h.01', 'M3 12h.01', 'M3 18h.01'],
  doc:      ['M6 3h8l4 4v14H6z', 'M14 3v4h4', 'M9 12h6', 'M9 16h6'],
  photo:    ['M3 5h18v14H3z', 'M3 15l5-5 4 4 3-3 6 6', 'M16 9h.01'],
  globe:    ['M12 21a9 9 0 100-18 9 9 0 000 18z', 'M3 12h18', 'M12 3c3 3 3 15 0 18', 'M12 3c-3 3-3 15 0 18'],
  arrowUp:  ['M12 20V4', 'M5 11l7-7 7 7'],
  arrowDown:['M12 4v16', 'M5 13l7 7 7-7'],
  wallet:   ['M3 7h16v12H3z', 'M3 7l2-3h12l2 3', 'M15 13h4'],
  hand:     ['M8 13V6a1.5 1.5 0 013 0v6', 'M11 11V4a1.5 1.5 0 013 0v7', 'M14 11V6a1.5 1.5 0 013 0v8a6 6 0 01-12 0v-3a1.5 1.5 0 013 0'],
  eye:      ['M2 12s4-7 10-7 10 7 10 7-4 7-10 7S2 12 2 12z', 'M12 15a3 3 0 100-6 3 3 0 000 6z'],
  smile:    ['M12 21a9 9 0 100-18 9 9 0 000 18z', 'M8 14s1.5 2 4 2 4-2 4-2', 'M9 9h.01', 'M15 9h.01'],
  spark:    ['M12 3l2 6 6 2-6 2-2 6-2-6-6-2 6-2z'],
  shirt:    ['M8 3l4 2 4-2 5 4-3 3-2-1v12H8V9L6 10 3 7z'],
  cup:      ['M5 5h11v9a5 5 0 01-10 0z', 'M16 7h2a2 2 0 010 4h-2', 'M5 21h12'],
  bed:      ['M3 18V8', 'M3 12h18v6', 'M21 18v-6', 'M7 12V9h5v3'],
  broom:    ['M15 3l6 6', 'M12 6l6 6', 'M12 6l-8 8 6 6 8-8z', 'M6 16l2 2'],
  paint:    ['M4 4h12v6H4z', 'M16 7h3v5h-8v3', 'M10 15h2v6h-2z'],
  hammer:   ['M14 4l6 6-2 2-6-6z', 'M12 6l2 2-9 9-2-2z', 'M5 15l4 4'],
  wrench:   ['M14 4a5 5 0 016 6l-9 9-3-3 9-9-3-3z', 'M3 21l3-3'],
  sofa:     ['M4 12V9h16v3', 'M2 12h20v6H2z', 'M5 18v2', 'M19 18v2'],
  piano:    ['M3 6h18v12H3z', 'M8 6v8', 'M13 6v8', 'M18 6v8'],
  stairs:   ['M3 21h5v-5h5v-5h5V6h3'],
  elevator: ['M5 3h14v18H5z', 'M12 3v18', 'M8 9l1.5-2L11 9', 'M13 15l1.5 2 1.5-2'],
  road:     ['M3 21L9 3h6l6 18', 'M12 7v2', 'M12 12v2', 'M12 17v2'],
  map:      ['M3 6l6-2 6 2 6-2v14l-6 2-6-2-6 2z', 'M9 4v14', 'M15 6v14'],
  weekday:  ['M4 5h16v15H4z', 'M4 10h16', 'M8 3v4', 'M16 3v4', 'M8 14h3', 'M13 14h3'],
  moon:     ['M20 14A8 8 0 0110 4a8 8 0 1010 10z'],
};

export const ICON_NAMES = Object.keys(ICONS);

// keyword → icon. Lower-cased whole-word or prefix match against the label.
// Order matters: first hit wins, so specific words come before broad ones.
const KEYWORDS = [
  ['weekday|weekend|monday|tuesday|wednesday|thursday|friday|saturday|sunday', 'weekday'],
  ['calendar|schedule|date|appointment|booking|book a|deadline|day|week|month', 'calendar'],
  ['movers?|crew|crews|team|staff|people|helpers?|guys', 'people'],
  ['clean|sweep|mop|dust|declutter|tidy|junk', 'broom'],
  ['pack|packing|box|boxes|carton|crate', 'box'],
  ['truck|haul|hauling|load|loading|unload|moving', 'truck'],
  ['house|home|apartment|condo|property|estate|rent|lease', 'house'],
  ['price|cost|pay|paid|fee|dollar|money|cash|budget|cheap|expensive|quote|invoice|deposit|save|savings|discount', 'dollar'],
  ['wallet|bank|account|fund', 'wallet'],
  ['time|hour|minute|clock|wait|early|late|fast|quick|speed', 'clock'],
  ['phone|call|text|sms|dial', 'phone'],
  ['email|mail|inbox|letter', 'mail'],
  ['message|chat|reply|dm|comment', 'message'],
  ['done|check|confirm|approve|yes|complete|finish|verified', 'check'],
  ['no|never|avoid|cancel|stop|remove|delete', 'x'],
  ['review|rating|star|rate|best|top|favorite', 'star'],
  ['tool|repair|fix|maintenance', 'tools'],
  ['wrench|plumb|pipe|leak', 'wrench'],
  ['hammer|build|construct|nail|frame', 'hammer'],
  ['paint|color|colour|wall', 'paint'],
  ['clean|sweep|mop|dust|declutter|tidy|junk', 'broom'],
  ['idea|tip|think|smart|learn|know|insight', 'bulb'],
  ['grow|growth|increase|profit|revenue|sales|up|more|gain|boost', 'chartUp'],
  ['drop|decrease|loss|down|less|fewer|cut|lower|reduce', 'chartDown'],
  ['team|crew|staff|people|customers|clients|family|friends|group|hire|workers', 'people'],
  ['customer|client|person|user|owner|you|me|someone|he|she|driver', 'person'],
  ['address|location|map|where|area|city|town|zip|route|miles|distance|drive|trip', 'pin'],
  ['photo|picture|image|camera|shot|screenshot', 'camera'],
  ['insurance|protect|safe|safety|secure|cover|coverage|warranty', 'shield'],
  ['key|keys|unlock|access|login|password', 'key'],
  ['shop|store|buy|purchase|order|cart|amazon', 'cart'],
  ['label|tag|brand|name|sku', 'tag'],
  ['gift|bonus|free|reward|prize', 'gift'],
  ['weather|sun|sunny|summer|heat|hot', 'sun'],
  ['cloud|rain|storm|backup|online|upload', 'cloud'],
  ['plant|garden|lawn|yard|green|eco|grass|tree', 'leaf'],
  ['love|like|care|kind|thank|heart', 'heart'],
  ['read|book|guide|manual|study|course|class|lesson', 'book'],
  ['write|note|draft|edit|sign|signature|form|fill', 'pencil'],
  ['search|find|look|research|google|compare', 'search'],
  ['setting|settings|config|setup|adjust|option|system|automate|automation', 'gear'],
  ['lock|private|privacy|permission', 'lock'],
  ['goal|target|milestone|finish line|flag|start', 'flag'],
  ['trash|garbage|throw|dump|waste|toss', 'trash'],
  ['recycle|donate|reuse|resell|sell', 'recycle'],
  ['weigh|weight|balance|compare|fair|legal|law|contract|scale', 'scale'],
  ['launch|rocket|grow fast|scale up|kick off|momentum', 'rocket'],
  ['fire|burn|urgent|hot lead|emergency', 'fire'],
  ['water|wash|rinse|flood|wet', 'water'],
  ['power|electric|energy|charge|battery|volt|bolt|lightning', 'bolt'],
  ['plug|outlet|wire|cable|cord|connect', 'plug'],
  ['car|vehicle|van|suv|parking|gas|fuel', 'car'],
  ['bike|bicycle|cycle', 'bike'],
  ['flight|fly|plane|travel|airport', 'plane'],
  ['music|song|audio|sound|speaker|listen|podcast', 'music'],
  ['work|job|business|office|company|career|shift', 'briefcase'],
  ['list|checklist|steps|items|inventory|todo|tasks|plan', 'list'],
  ['document|paper|file|pdf|receipt|record|report|contract', 'doc'],
  ['website|web|site|internet|online|page|url|link|domain', 'globe'],
  ['lift|raise|carry|stack|pile', 'arrowUp'],
  ['lower|drop off|set down|unload', 'arrowDown'],
  ['help|hand|assist|support|hold|grab', 'hand'],
  ['see|watch|view|look at|inspect|check out|eye', 'eye'],
  ['happy|smile|enjoy|fun|relax|easy', 'smile'],
  ['new|fresh|shine|sparkle|magic|special|wow', 'spark'],
  ['clothes|shirt|wardrobe|closet|laundry', 'shirt'],
  ['coffee|drink|cup|kitchen|dish|dishes|glass', 'cup'],
  ['bed|mattress|sleep|bedroom|rest|night', 'bed'],
  ['couch|sofa|furniture|chair|table|desk|dresser', 'sofa'],
  ['piano|heavy|bulky|large|big|oversize', 'piano'],
  ['stairs|stair|floor|story|upstairs|downstairs|walk-up', 'stairs'],
  ['elevator|lift', 'elevator'],
  ['road|highway|street|long distance|mileage', 'road'],
  ['evening|night|dark|late night|overnight', 'moon'],
];

const COMPILED = KEYWORDS.map(([re, icon]) => [new RegExp(`(^|[^a-z])(${re})([^a-z]|$)`, 'i'), icon]);

/** Pick an icon name for a label; null when nothing in the vocabulary fits. */
export function iconFor(label) {
  const s = String(label || '').toLowerCase();
  if (!s) return null;
  for (const [re, icon] of COMPILED) if (re.test(s)) return icon;
  return null;
}

export function hasIcon(name) { return !!(name && ICONS[name]); }
